"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      searchData: {
        countryRegionalId: 0,
        page: 1,
        rows: 10 },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      tableData: [], //表格数据
      tableColumns: [
      {
        label: '国家地区',
        prop: 'countryRegionalName' },

      {
        label: '语言',
        prop: 'locale' },

      {
        label: '内容',
        prop: 'content' }],

      //表头数据
      showAdd: false, //是否显示新增||编辑弹窗
      countryForm: {
        id: 0,
        countryRegionalId: '',
        country: '',
        locale: '',
        content: '',
        createTime: '' },
      //新增||编辑表单
      countryFormRule: {
        locale: [{
          required: true,
          message: '请选择语言',
          trigger: ['change'] }],

        content: [{
          required: true,
          message: '请填写内容',
          trigger: ['change', 'blur'] }] },

      //新增||编辑表单校验规则
      languageList: [], //语言列表
      parentId: 0, //父级id
      parentName: '' //父级名称
    };
  },

  mounted: function mounted() {
    this.parentId = this.$route.params.parentId;
    this.parentName = this.$route.params.parentName;
    this.$set(this.searchData, 'countryRegionalId', this.parentId);
    this.$set(this.countryForm, 'countryRegionalId', this.parentId);
    this.$set(this.countryForm, 'country', this.parentName);
    this.initPage();
  },

  methods: {
    /**
              * 页面初始化
              */
    initPage: function initPage() {
      this.fetchList();
      this.fetchLanguageList();
    },

    /**
        * 获取列表
        */
    fetchList: function fetchList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/faCountryRegional/getMultiLanguage', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取语言列表
        */
    fetchLanguageList: function fetchLanguageList() {var _this2 = this;
      this.getData('/api/language/list', {}, function (res) {
        _this2.languageList = res;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'name', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchList();
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.countryForm, 'id', row.id);
      this.$set(this.countryForm, 'locale', row.locale);
      this.$set(this.countryForm, 'content', row.content);
      this.$set(this.countryForm, 'createTime', row.createTime);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this3 = this;
      this.$confirm('确定删除当前语言？', '提示', { type: 'warning' }).then(function (res) {
        //删除通知
        _this3.delData("/api/faCountryRegional/deleteMultiLanguage/".concat(row.id), {}, function (res) {
          _this3.fetchList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.countryForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this5 = this;
      this.$nextTick(function () {
        Object.keys(_this5.countryForm).forEach(function (e) {
          if (e == 'country') {
            _this5.$set(_this5.countryForm, e, _this5.parentName);
            return;
          }
          if (e == 'countryRegionalId') {
            _this5.$set(_this5.countryForm, e, _this5.parentId);
            return;
          }
          _this5.$set(_this5.countryForm, e, '');
        });
        _this5.$refs.countryForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 保存
        */
    onSaveCountry: function onSaveCountry() {var _this6 = this;
      this.$refs.countryForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.countryForm);
          delete params['country'];
          if (params.id) {
            //编辑
          } else {
            //新增
            delete params['id'];
            delete params['createTime'];
          }
          _this6.postData('/api/faCountryRegional/saveMultiLanguage', params, function (res) {
            _this6.showAdd = false;
            _this6.fetchList();
          });
        }
      });
    } } };exports.default = _default;